import { createRouter, createWebHistory } from 'vue-router';

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: "Login",
      path: window.in_discord ? "/.proxy/login" : '/login',
      component: () => import("../views/Login"),
      props: true
    },
    {
      name: "CreateAccount",
      path: "/create-account",
      component: () => import("../views/CreateAccount"),
      props: true
    },
    {
      name: "ForgotPassword",
      path: "/forgot-password",
      component: () => import("../views/ForgotPassword")
    },
    {
      name: "ResetPassword",
      path: "/reset-password/:recoveryCode",
      component: () => import("../views/ResetPassword"),
      props: true,
    },
    {
      name: "AcceptInvite",
      path: "/accept-invite/:campaign_id/:campaign_public_key",
      // On Accept invite redirect to campaign they were invited to
      // On Create Account move redirect there as well
      component: () => import("../views/Login"),
      props: true
    },
  ]
});